import React, { useState } from 'react';
import { photographyData } from '../Components/data'; // Import your data

const Photography = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="portfolio-container">
      <h1 className="title">Portfolio</h1>

      {photographyData.map((section) => (
        <div key={section.category} className="photo-section">
          <h2 className="section-title">{section.category}</h2>
          
          <div className="grid">
            {section.images.map((img) => (
              <div 
                key={img.id} 
                className="grid-item" 
                onClick={() => setSelectedImg(img.full)}
              >
                <img src={img.thumb} alt={img.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Lightbox */}
      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <div className="lightbox-content">
            <img src={selectedImg} alt="Enlarged" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Photography;